import { __awaiter } from "tslib";
import { PaymentStatus } from '@wix/wix-vod-constants/api-types';
import { PublicPurchaseService } from './purchase';
import { buildUrl, openBlankTab, URL_PARAM_COMP_ID, URL_PARAM_PAYMENT_TYPE, URL_PARAM_STATE, URL_PARAM_VIDEO_ID, URL_STATE_COMPLETE_PURCHASE, } from '@wix/wix-vod-shared/common';
import { getBsi } from '@wix/wix-vod-shared/dist/esm/widget/vod-player/components/share-buttons/utils';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
const APIUrls = {
    order: '/cashier/order',
    status: (order, transaction) => `/cashier/order/${order}/transaction/${transaction}/status`,
};
const BASE_URL = `${PRODUCTION_HOSTS.paypal}/vod`;
const statusesMap = {
    SUCCESS: PaymentStatus.ACTIVE,
    APPROVED: PaymentStatus.ACTIVE,
    OK: PaymentStatus.ACTIVE,
    PENDING: PaymentStatus.PENDING,
    PENDING_MERCHANT: PaymentStatus.PENDING,
    CANCEL: PaymentStatus.CANCELED,
    CANCELED: PaymentStatus.CANCELED,
};
export class PublicPurchaseServiceV2 extends PublicPurchaseService {
    constructor(httpClient) {
        super();
        this.httpClient = httpClient;
    }
    createOrder(videoId, channelId, paymentType, siteUrl, instance, compId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.httpClient.post(`${BASE_URL}${APIUrls.order}`, {
                channelId,
                refItemId: videoId,
                type: paymentType,
                ref: siteUrl,
                redirectParams: {
                    returnUrl: siteUrl,
                    [URL_PARAM_COMP_ID]: compId,
                    [URL_PARAM_VIDEO_ID]: videoId,
                    [URL_PARAM_PAYMENT_TYPE]: paymentType,
                    [URL_PARAM_STATE]: URL_STATE_COMPLETE_PURCHASE,
                },
            }, {
                params: { instance, bsi: getBsi() },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true,
                xsrfCookieName: null,
                xsrfHeaderName: null,
            });
            return data.order.id;
        });
    }
    getPaymentStatus(videoId, channelId, orderId, transactionId, instance, paymentType) {
        return __awaiter(this, void 0, void 0, function* () {
            const { status } = yield this.httpClient
                .get(`${BASE_URL}${APIUrls.status(orderId, transactionId)}`, {
                params: { instance, bsi: getBsi() },
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true,
                xsrfCookieName: null,
                xsrfHeaderName: null,
            })
                .then((response) => ({ status: response.data.status }), (error) => ({ status: 'ERROR', error }));
            return statusesMap[status];
        });
    }
    cancelOrder(channelId, siteUrl, instance) {
        return __awaiter(this, void 0, void 0, function* () {
            openBlankTab(buildUrl(`${PRODUCTION_HOSTS.paypal}/vod/pp/subscribe/cancel_profile`, {
                type: 'subscription',
                channelId,
                ref: siteUrl,
                instance,
            }));
        });
    }
}
//# sourceMappingURL=purchase.v2.js.map